/* eslint-disable no-secrets/no-secrets */
import React, { useEffect, useState, useCallback, useMemo, useReducer, useRef } from 'react';
import _, { toUpper } from 'lodash';
import { useHistory } from 'react-router-dom';
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { ModalNextProvider, ModalNextEmitter, useModal } from '@jutro/components';
import './App.scss';
import { ViewModelServiceFactory } from '@xengage/gw-portals-viewmodel-js';
import { DependencyProvider } from '@xengage/gw-portals-dependency-react';
import { policyJobComponentMap, policyJobComponents } from 'gw-capability-policyjob-react';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { AccurateBreakpointPropagation } from '@xengage/gw-jutro-adapters-react';
import { useTranslator } from '@jutro/locale';
import vmTranslator from '@xengage/gw-platform-translations';
import {
    MLNotificationBlockContext, MLNotificationBlockReducer,
    MLProgressModalContext, MLProgressModalReducer,
    MLWizardDataSnapshotContext
} from 'ml-portals-util-react';
import {
    platformComponents,
    platformComponentMap,
    ImageComponent,
    KnockOutPage
} from 'gw-components-platform-react';
import PELandingPage, {
    Accounts,
    Policies,
    Activities,
    Analytics,
    AccountDetails,
    PolicyDetails,
    NewQuotePage,
    SearchResults,
    MLSearchResults,
    MLARSSearchResults,
    QuoteDetails,
    Renewal,
    Endorsement,
    Cancellation,
    AccountBillingAndPayment,
    MakePayment,
    ContactUnderwriter,
    PaymentConfirmation,
    producerEngageComponentMap,
    producerEngageAdditionalComponents,
    MLViewAllPoliciesPage,
    PageHeaderComponent,
    ActivityReportsPage,
    MLPELandingPage,
    MLContactUs
} from 'gw-capability-gateway-react';
import { SelectProducerContextProvider } from 'gw-gateway-common-react';
import { Redirect } from 'react-router-dom';
import { MLTagManagerService } from 'ml-portals-services-react';
import { MLTimeService } from 'ml-capability-time';
import { ErrorBoundary } from '@xengage/gw-portals-error-react';

import {
    useAuthentication,
    withAuthenticationProvider
} from '@xengage/gw-digital-auth-react';
import { GatewayAvailabilityService } from 'gw-capability-gateway-policycommon';
import { GatewayRenewalService } from 'gw-capability-gateway-policyrenewal';
import { GatewayEndorsementService } from 'gw-capability-gateway-policychange';
import { LoadSaveService, CustomQuoteService } from 'gw-capability-gateway-quoteandbind';
import { UserService, SubmissionService, JobService, PolicyService } from 'gw-capability-gateway';
import { BopCoverablesService } from 'gw-capability-gateway-policyjob-bop';
import { GatewayClaimService } from 'gw-capability-gateway-claim';
import { GatewayBillingService } from 'gw-capability-gateway-billing';
import { GatewayFNOLService } from 'gw-capability-gateway-fnol';
import { AccountService } from 'gw-capability-gateway-policy';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { GatewaySpreadsheetService } from 'gw-capability-gateway-spreadsheet';
import { ProducerInfoService } from 'gw-capability-profileinfo';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-components-ui';
import { PropertyCodeLookupService } from 'gw-capability-quoteandbind-cp';
import { AddressLookupComponentMap, AddressLookupComponents } from 'gw-capability-address-react';
import { VehicleInfoLookupComponentMap, VehicleInfoLookupComponents } from 'gw-capability-vehicleinfo-react';
import { GatewayClaimDocumentService } from 'gw-capability-gateway-claimdocument';
import { filterCapabilityRoutes } from '@xengage/gw-portals-config-js';
import { PolicyDocumentError } from 'gw-capability-document-react';
import BaseFNOLWizard, { ClaimsConfirmationPage } from 'gw-capability-fnol-common-react';
import { ContactAgentPage, Preferences } from 'gw-pages-platform-react';
import FNOLHOWizard from 'gw-capability-fnol-ho-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import FNOLCPWizard from 'gw-capability-fnol-cp-react';
import FNOLWCWizard from 'gw-capability-fnol-wc-react';
import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';
import { PEWC7Wizard } from 'gw-capability-gateway-quoteandbind-wc7-react';
import { PEPAWizard } from 'gw-capability-gateway-quoteandbind-pa-react';
import { PEHOWizard } from 'gw-capability-gateway-quoteandbind-ho-react';
import { PEPUPWizard } from 'gw-capability-gateway-quoteandbind-pup-react';
import { PEBOPWizard } from 'gw-capability-gateway-quoteandbind-bop-react';
import { PECPWizard } from 'gw-capability-gateway-quoteandbind-cp-react';
import { PAPolicyChangeWizard } from 'gw-capability-policychange-pa-react';
import { HOPolicyChangeWizard } from 'gw-capability-policychange-ho-react';
import { PUPPolicyChangeWizard } from 'gw-capability-policychange-pup-react';
import { CPPolicyChangeWizard } from 'gw-capability-gateway-policychange-cp-react';
import { BOPPolicyChangeWizard } from 'gw-capability-gateway-policychange-bop-react';
import { CPPolicyRenewalWizard } from 'gw-capability-gateway-policyrenewal-cp-react';
import { BOPPolicyRenewalWizard } from 'gw-capability-gateway-policyrenewal-bop-react';
import FaqPage from 'gw-capability-faq-react';
import { ClaimDetails } from 'gw-capability-claim-react';
import { ClaimsLanding } from 'gw-capability-gateway-claim-react';
import { CommissionLanding } from 'gw-capability-gateway-commission-react';
import { CancellationWizard, MLCancellationContactUsPage } from 'ml-capability-policychange-cancellation-react';
import { ReinstatementWizard, MLReinstatementContactUsPage } from 'ml-capability-reinstatement-react';
import { MLEndorsementContactUsPage } from 'ml-capability-policychange-common-react';
import { RewriteWizard, MLRewriteContactUsPage } from 'ml-capability-rewrite-react';
import { customerPlatformComponentMap, customerPlatformComponents, MLProgressModal } from 'ml-components-platform-react';

import { MLAddressLookupComponentMap, MLAddressLookupComponents } from 'ml-components-address-react';
import {
    customerGatewayQuoteAndBindCommonComponentMap,
    customerGatewayQuoteAndBindCommonComponents,
    MLNewQuoteAccountSearchComponent,
    MLAccountDetails,
    MLPolicyDetails,
    MLBundleConfirmation,
    MLBundleCart,
    MLGatewayHVQLandingPage,
    MLGatewayCompRaterWizard
} from 'gw-capability-gateway-quoteandbind-common-react';
import { customerGatewayPolicyChangePAComponentMap, customerGatewayPolicyChangePAComponents } from 'gw-capability-gateway-policychange-pa-react';
import { customerGatewayPolicyChangePUPComponentMap, customerGatewayPolicyChangePUPComponents } from 'gw-capability-gateway-policychange-pup-react';
import { CustomFooterComponent } from 'gw-capability-quoteandbind-common-react';
import { AskForemostPage, MLQuoteEntry } from 'ml-capability-quoteandbind-common-react';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import productMetadata from 'product-metadata'
import messages from './App.messages';

import appRoutes from './App.routes.metadata.json5';
import { AppFloorPlan } from '@jutro/legacy/floorplan';

const modalEmitter = new ModalNextEmitter();
const PROD_ENV = 'prod'
const { capabilitiesConfig, gatewayAnalytics, runtimeEnv } = appConfig;

const componentMap = {
    landingpage: PELandingPage,
    accounts: Accounts,
    policies: Policies,
    activities: Activities,
    analytics: Analytics,
    accountdetails: MLAccountDetails,
    policydetails: MLPolicyDetails,
    newquotepage: NewQuotePage,
    searchresults: SearchResults,
    mlsearchresults: MLSearchResults,
    mlarssearchresults: MLARSSearchResults,
    quotedetails: QuoteDetails,
    renewal: Renewal,
    endorsement: Endorsement,
    cancellation: Cancellation,
    accountbillingandpayment: AccountBillingAndPayment,
    makepayment: MakePayment,
    contactunderwriter: ContactUnderwriter,
    paymentconfirmation: PaymentConfirmation,
    basefnolwizard: BaseFNOLWizard,
    claimsconfirmationpage: ClaimsConfirmationPage,
    contactagentpage: ContactAgentPage,
    preferences: Preferences,
    fnolhowizard: FNOLHOWizard,
    fnolpawizard: FNOLPAWizard,
    fnolcawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolwcwizard: FNOLWCWizard,
    fnolbopwizard: FNOLBOPWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    pewc7wizard: PEWC7Wizard,
    pepawizard: PEPAWizard,
    pehowizard: PEHOWizard,
    pepupwizard: PEPUPWizard,
    pebopwizard: PEBOPWizard,
    pecpwizard: PECPWizard,
    papolicychangewizard: PAPolicyChangeWizard,
    hopolicychangewizard: HOPolicyChangeWizard,
    puppolicychangewizard: PUPPolicyChangeWizard,
    cppolicychangewizard: CPPolicyChangeWizard,
    boppolicychangewizard: BOPPolicyChangeWizard,
    cppolicyrenewalwizard: CPPolicyRenewalWizard,
    boppolicyrenewalwizard: BOPPolicyRenewalWizard,
    compraterwizard: MLGatewayCompRaterWizard,
    faqpage: FaqPage,
    knockoutpage: KnockOutPage,
    claimdetails: ClaimDetails,
    claimslanding: ClaimsLanding,
    commissionlanding: CommissionLanding,
    policydocumenterror: PolicyDocumentError,
    mlnewquoteaccountsearchcomponent: MLNewQuoteAccountSearchComponent,
    activityreportspage: ActivityReportsPage,
    mlviewallpolicies: MLViewAllPoliciesPage,
    mlpelandingpage: MLPELandingPage,
    MLBundleCart: MLBundleCart,
    quoteentry: MLQuoteEntry,
    mlgatewayhvqlandingpage: MLGatewayHVQLandingPage,
    MLBundleConfirmation: MLBundleConfirmation,
    MLContactUs: MLContactUs,
    cancellationwizard: CancellationWizard,
    mlcancellationcontactuspage: MLCancellationContactUsPage,
    mlendorsementcontactuspage: MLEndorsementContactUsPage,
    rewritewizard: RewriteWizard,
    mlrewritecontactuspage: MLRewriteContactUsPage,
    reinstatementwizard: ReinstatementWizard,
    mlreinstatementcontactuspage: MLReinstatementContactUsPage,
    askforemostpage: AskForemostPage
};

setComponentMapOverrides({
    ...platformComponentMap,
    ...AddressLookupComponentMap,
    ...VehicleInfoLookupComponentMap,
    ...producerEngageComponentMap,
    ...policyJobComponentMap,
    ...customerPlatformComponentMap,
    ...customerPlatformComponentMap,
    ...MLAddressLookupComponentMap,
    ...customerGatewayQuoteAndBindCommonComponentMap,
    ...customerGatewayPolicyChangePAComponentMap,
    ...customerGatewayPolicyChangePUPComponentMap,
    WizardPageTemplateWithTitle: { component: 'WizardPageTemplateWithTitle' },
    // replace the native IMG component with a proxied version
    img: { component: 'img' }
},
{
    ...platformComponents,
    ...AddressLookupComponents,
    ...VehicleInfoLookupComponents,
    ...producerEngageAdditionalComponents,
    ...policyJobComponents,
    ...customerPlatformComponents,
    ...customerPlatformComponents,
    ...MLAddressLookupComponents,
    ...customerGatewayQuoteAndBindCommonComponents,
    ...customerGatewayPolicyChangePAComponents,
    ...customerGatewayPolicyChangePUPComponents,
    WizardPageTemplateWithTitle,
    img: ImageComponent
});

const defaultRoutes = filterCapabilityRoutes(capabilitiesConfig, appRoutes.routes);

const getUserAuthData = (authData) => {
    return UserService.getCurrentUser(authData.authHeader).catch((error) => {
        if(authData) { authData.logout(); } 
    });
};

function App() {
    const modalApi = useModal(); 
    const auth = useAuthentication();
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const history = useHistory();    
    const [permissionCheck, updatePermissionCheck] = useState(false);
    const [routes, updateRoutes] = useState(defaultRoutes);
    const [notificationBlock, setNotificationBlock] = useReducer(MLNotificationBlockReducer, []);
    const [progressModalState, updateProgressModalState] = useReducer(MLProgressModalReducer, { active: false, count :0 });
    const wizardDataWithSnapshotFlag = useRef(false);

    useEffect(() => {
        const urlParameter = window.location.search;
        const cookieExists  = document.cookie.split('; ').includes('?MFA_Register=Y');

        if (urlParameter && urlParameter.indexOf('?MFA_Register') > -1) {
            document.cookie = "?MFA_Register=Y; path=/";
        } else if (!cookieExists) {

            const JWTToken=JSON.stringify(authHeader);
            const token = JSON.parse(JWTToken).Authorization;
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace("-", "+").replace("_", "/");
            const result = JSON.parse(window.atob(base64));
            const isMFAGroup = result?.farmers_mfa?.includes('MFA Register');

            if (isMFAGroup) {
                if (runtimeEnv === PROD_ENV) { 
                    window.location.href= 'https://fwsia.okta.com/oauth2/ausbxbj3v1dF3acJB697/v1/authorize?client_id=0oabuf5sg1A3KjI4E697&response_type=code&scope=mfa%20openid%20offline_access&redirect_uri=https://iaagenta360.agentautohome.com/agent&state=profile_A360';
                } else {                    
                    window.location.href= 'https://fwsia.oktapreview.com/oauth2/ausc5e3rowebDIv8F1d7/v1/authorize?client_id=0oac5dnmybCyHJORP1d7&response_type=code&scope=mfa openid offline_access&redirect_uri=https://iaagenta360qa.agentautohome.com/agent&state=profile_A360';
                }        
            }
        }

    }, [authHeader])    

    useEffect(() => {
        MLTagManagerService.init(auth);
        MLTimeService.init(auth.authHeader);

        window.localStorage.setItem('hasServicesCallError', false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {        
        const currentUrl = history?.location?.pathname;
        let newUrl = currentUrl
        let redirect = false;
        
        // Post-Jasper issue where /producer-engage is coming in URL after deep link,
        if (currentUrl && currentUrl.indexOf('/producer-engage') === 0) {
            newUrl = newUrl.substring(16)
            redirect = true
        }

        // Post Hakuba changes - After refresh URL ends with extra '/'. So removing it to avoid redirect issues.
        if (currentUrl && currentUrl.charAt(currentUrl.length - 1) === '/') {
            newUrl = newUrl.replace(/\/\s*$/,"");  
            redirect = true;
        }

        if (redirect) {
            history.replace({pathname: newUrl});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleError = useCallback((error = {}) => {
        // fail-safe to hide progress dialog if it's open when an error occured (specially from class components).
        updateProgressModalState({ type: 'RESET' });
        const state = {
            pathname: '/contactUs',
            state: error
        };

        window.localStorage.setItem('hasServicesCallError', true);
        // Skipping the popup with error and redirect immediately. Just like v9.,
        return <Redirect to={state} />;
    }, []);

    const checkViewCommissionsAnalyticsPermission = useCallback(() => {
        const commissionsDTO = {
            permission: 'viewcommissions'
        };

        const reportsDTO = {
            permission: 'gpaviewreports'
        };

        if (_.isEmpty(auth.authHeader) || permissionCheck) {
            return;
        }
        updatePermissionCheck(true);

        const commissionPermission = UserService.hasUserSystemPermission(commissionsDTO, auth.authHeader);

        const analyticsPermission = UserService.hasUserSystemPermission(reportsDTO, auth.authHeader);

        Promise.all([commissionPermission, analyticsPermission])
            .then(([hasCommission, hasAnalytics]) => {

                const routesToBeUpdated = ['/commission', '/analytics'];
                let updatedRoutes = 0;

                for (const route of routes) {
                    if (routesToBeUpdated.includes(route.path)) {
                        updatedRoutes++;
                        route.showOnNavBar = (
                            route.path === '/commission' ? hasCommission : gatewayAnalytics && hasAnalytics
                        );
                    }

                    if (routesToBeUpdated.length === updatedRoutes) {
                        break;
                    }
                }
                updateRoutes([...routes]);
            });


    }, [auth.authHeader, permissionCheck, routes]);

    const floorPlansConfig = useMemo(() => {
        return [{
            scrollContent: false,
            showFooter: false,
            routes: routes,
            showHeader: false,
            showSubHeader: false,
            header: {}
        }];
    }, [routes]);

    useEffect(() => {
        checkViewCommissionsAnalyticsPermission();
    }, [checkViewCommissionsAnalyticsPermission]);

    useEffect(() => {
        _.set(window, '__gifws.modalApi', { modalApi});
    }, [modalApi]);

    const viewModelService = useMemo(() => {
        const translatorFn = vmTranslator(translator);

        return ViewModelServiceFactory.getViewModelService(productMetadata, translatorFn)
    }, [])

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    BopCoverablesService: BopCoverablesService,
                    LoadSaveService: LoadSaveService,
                    CustomQuoteService: CustomQuoteService,
                    ClaimService: GatewayClaimService,
                    ClaimDownloadService: GatewayClaimDocumentService,
                    FNOLService: GatewayFNOLService,
                    AvailabilityService: GatewayAvailabilityService,
                    RenewalService: GatewayRenewalService,
                    DocumentService: GatewayDocumentService,
                    SpreadsheetService: GatewaySpreadsheetService,
                    EndorsementService: GatewayEndorsementService,
                    AccountService: AccountService,
                    BillingService: GatewayBillingService,
                    UserService: UserService,
                    PropertyCodeLookupService: PropertyCodeLookupService,
                    ContactService: ProducerInfoService,
                    PolicyService: PolicyService,
                    quoteUnderWritingService: {
                        referToUnderwriter: SubmissionService.referToUnderwriter,
                        withdrawJobByJobNumber: JobService.withdrawJobByJobNumber,
                        approveUnderwritingIssue: LoadSaveService.approveUnderwritingIssue
                    }
                }}
            >
                <ViewModelServiceContext.Provider value={viewModelService}>
                    <MLProgressModalContext.Provider value={{ progressModalState, updateProgressModalState }}>
                        <MLNotificationBlockContext.Provider value={{ notificationBlock, setNotificationBlock }}>
                            <MLWizardDataSnapshotContext.Provider value={{ wizardDataWithSnapshotFlag }}>
                                <ErrorBoundary onError={handleError}>
                                    <ModalNextProvider>
                                        <React.Fragment>
                                        <div className="peContent">
                                            <PageHeaderComponent />
                                            <SelectProducerContextProvider authHeader={auth.authHeader}>
                                                <AppFloorPlan componentMap={componentMap} floorPlans={floorPlansConfig} />
                                            </SelectProducerContextProvider>
                                        </div>
                                        {/* Chat Bot Div */}
                                        <div id="chat-wizard-root"></div>
                                        </React.Fragment>
                                    </ModalNextProvider>
                                </ErrorBoundary>
                                <CustomFooterComponent />
                            </MLWizardDataSnapshotContext.Provider>
                        </MLNotificationBlockContext.Provider>
                        <MLProgressModal />
                    </MLProgressModalContext.Provider>
                </ViewModelServiceContext.Provider>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}
export default withAuthenticationProvider({onAuthDataCreation: getUserAuthData })(App);
